var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { alpha, styled, ToggleButton } from "@mui/material";
import { TruffleSvgGradientId } from "../../Utils";
export const ToggleIconButton = forwardRef((_a, ref) => {
    var { icon } = _a, props = __rest(_a, ["icon"]);
    return (_jsx(CustomToggleButton, Object.assign({ ref: ref }, props, { children: icon })));
});
const CustomToggleButton = styled(ToggleButton)(({ theme: { palette } }) => ({
    borderRadius: "50%",
    border: "none",
    "&.MuiToggleButton-sizeSmall": {
        width: "24px",
        height: "24px",
        padding: "6px",
        fontSize: "12px"
    },
    "&.MuiToggleButton-sizeMedium": {
        width: "32px",
        height: "32px",
        padding: "8px",
        fontSize: "16px"
    },
    "&.MuiToggleButton-sizeLarge": {
        height: "36px",
        width: "36px",
        padding: "10px",
        fontSize: "16px"
    },
    "&.MuiToggleButton-standard": {
        "&:hover:not(.Mui-selected)": {
            backgroundColor: alpha(palette.primary.main, palette.action.hoverOpacity),
            "& > svg": {
                color: palette.primary.main
            }
        },
        "&.Mui-selected": {
            backgroundColor: alpha(palette.primary.main, palette.action.selectedOpacity),
            "& > svg": {
                color: palette.primary.main
            }
        },
        "&.Mui-focusVisible": {
            color: "transparent",
            backgroundColor: alpha(palette.primary.main, palette.action.focusOpacity),
            "& > svg": {
                color: palette.primary.main
            }
        }
    },
    "&.MuiToggleButton-primary": {
        "& > svg": {
            color: palette.primary.main
        },
        "&:hover:not(.Mui-selected)": {
            backgroundColor: alpha(palette.primary.main, palette.action.hoverOpacity)
        },
        "&.Mui-focusVisible": {
            color: "transparent",
            backgroundColor: alpha(palette.primary.main, palette.action.focusOpacity)
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: palette.primary.main
        }
    },
    "&.MuiToggleButton-secondary": {
        "& > svg": {
            color: palette.secondary.main
        },
        "&:hover:not(.Mui-selected)": {
            backgroundColor: alpha(palette.secondary.main, palette.action.hoverOpacity)
        },
        "&.Mui-focusVisible": {
            color: "transparent",
            backgroundColor: alpha(palette.secondary.main, palette.action.focusOpacity)
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: palette.secondary.main
        }
    },
    "&.Mui-error": {
        "& > svg": {
            color: palette.error.main
        },
        "&:hover:not(.Mui-selected)": {
            backgroundColor: alpha(palette.error.main, palette.action.hoverOpacity)
        },
        "&.Mui-focusVisible": {
            color: "transparent",
            backgroundColor: alpha(palette.error.main, palette.action.focusOpacity)
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: palette.error.main
        }
    },
    "&.MuiToggleButton-info": {
        "& > svg": {
            color: palette.info.main
        },
        "&:hover:not(.Mui-selected)": {
            backgroundColor: alpha(palette.info.main, palette.action.hoverOpacity)
        },
        "&.Mui-focusVisible": {
            color: "transparent",
            backgroundColor: alpha(palette.info.main, palette.action.focusOpacity)
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: palette.info.main
        }
    },
    "&.MuiToggleButton-success": {
        "& > svg": {
            color: palette.success.main
        },
        "&:hover:not(.Mui-selected)": {
            backgroundColor: alpha(palette.success.main, palette.action.hoverOpacity)
        },
        "&.Mui-focusVisible": {
            color: "transparent",
            backgroundColor: alpha(palette.success.main, palette.action.focusOpacity)
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: palette.success.main
        }
    },
    "&.MuiToggleButton-warning": {
        "& > svg": {
            color: palette.warning.main
        },
        "&:hover:not(.Mui-selected)": {
            backgroundColor: alpha(palette.warning.main, palette.action.hoverOpacity)
        },
        "&.Mui-focusVisible": {
            color: "transparent",
            backgroundColor: alpha(palette.warning.main, palette.action.focusOpacity)
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: palette.warning.main
        }
    },
    "&.MuiToggleButton-white": {
        "& > svg": {
            color: palette.white.main
        },
        "&:hover:not(.Mui-selected)": {
            backgroundColor: alpha(palette.white.main, palette.action.hoverOpacity)
        },
        "&.Mui-focusVisible": {
            color: "transparent",
            backgroundColor: alpha(palette.white.main, palette.action.focusOpacity)
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: palette.white.main
        }
    },
    "&.MuiToggleButton-gradient": {
        ":not(.Mui-selected):not(.Mui-disabled)": {
            "& > svg": {
                "& path": {
                    fill: `url(#${TruffleSvgGradientId})`
                }
            }
        },
        "&:hover:not(.Mui-selected)": {
            backgroundColor: alpha(palette.gradient.main, palette.action.hoverOpacity)
        },
        "&.Mui-focusVisible": {
            color: "transparent",
            backgroundColor: alpha(palette.gradient.main, palette.action.focusOpacity)
        },
        "& .MuiTouchRipple-child": {
            backgroundColor: palette.gradient.main
        }
    },
    "&.Mui-disabled": {
        border: "none",
        "& > svg": {
            color: palette.action.disabled
        }
    }
}));
//# sourceMappingURL=ToggleIconButton.js.map